/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFolderOpenFavorite = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m13.743 14.286 2.257.486-1.709 1.637.36 2.591-2.151-1.147L10.35 19l.359-2.59L9 14.771l2.257-.486L12.5 12z" />
        <path d="M12.535 5H20v4h2.31l-3.546 13H2V2h8.535zM4.31 20h12.926l2.454-9H6.764zM4 13.532 5.236 9H18V7h-6.535l-2-3H4z" />
      </g>
    </g>
  </Icon>
);
export { SvgFolderOpenFavorite as FolderOpenFavorite };
